import React from "react";
import { Box, Typography } from "@mui/material";
import Logo from "../../assets/PaymentOrder/logoPaginaJudicial.png";

const ReceiptPaymentOrder = ({ data }) => {
  if (!data) return null;

  const {
    code,
    expediente,
    amount,
    hash_operation,
    date,
    cbu_origin,
    cbu_destinity,
    cuit_beneficiary,
    cuit_addressee,
    retention,
  } = data;

  let parsedRetentions = [];

  try {
    parsedRetentions = JSON.parse(retention);
  } catch (e) {
    console.warn("No se pudo parsear retenciones", e);
  }

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        color: "rgba(0,0,0,0.87)",
        borderLeft: "0.25rem solid #00958d",
        borderRadius: "8px",
        boxShadow: "0 .15rem .5rem #3a3b4526",
        display: "block",
        fontSize: "17px",
        overflowX: "auto",
        padding: "9px 24px",
        whiteSpace: "nowrap",
        width: "85%",
        mx: "auto",
        "& .MuiTypography-root": { color: "rgba(0,0,0,0.87)" },
      }}
    >
      {/* Imagen */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <img src={Logo} alt="logoJusticia" style={{ height: "60px" }} />
      </Box>

      <Typography
        fontWeight="bold"
        mb={2}
        sx={{ textAlign: "center" }} // <-- solo esto centrado
      >
        COMPROBANTE DE TRANSFERENCIA EMITIDO POR BANCOR
      </Typography>

      {/* Sección: Transferencia */}
      <Box className="comprobanteContainer_dataBody" mb={2}>
        <Typography
          className="comprobanteContainer_title"
          fontWeight="bold"
          mb={1}
        >
          Transferencia
        </Typography>

        <ComprobanteRow label="Número de Orden de Pago:" value={code} />
        <ComprobanteRow label="N° Expediente:" value={expediente} />
        <ComprobanteRow label="N° de Operación:" value={hash_operation} />
      </Box>

      {/* Detalle de Transferencia */}
      <Box className="comprobanteContainer_dataBody" mb={2}>
        <Typography
          className="comprobanteContainer_title"
          fontWeight="bold"
          mb={1}
        >
          Detalle de Transferencia
        </Typography>

        <ComprobanteRow
          label="Importe transferido:"
          value={new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS",
            minimumFractionDigits: 2,
          }).format(amount)}
        />
        <ComprobanteRow label="Fecha y Hora de realización:" value={date} />
        <ComprobanteRow label="CBU Cuenta origen:" value={cbu_origin} />
        <ComprobanteRow label="CBU Cuenta destino:" value={cbu_destinity} />
        <ComprobanteRow
          label="CUIT / CUIL del Beneficiario:"
          value={`${cuit_beneficiary}`}
        />
        <ComprobanteRow
          label="CUIT / CUIL del Destinatario:"
          value={`${cuit_addressee}`}
        />
      </Box>

      {/* Conceptos */}
      <Box className="comprobanteContainer_dataBody">
        <Typography
          className="comprobanteContainer_title"
          fontWeight="bold"
          mb={1}
        >
          Conceptos
        </Typography>

        {Array.isArray(parsedRetentions) && parsedRetentions.length > 0 ? (
          parsedRetentions.map((concepto, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <ComprobanteRow label="Concepto:" value={concepto.tipoConcepto} />
              <ComprobanteRow
                label="Importe Concepto:"
                value={new Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  minimumFractionDigits: 2,
                }).format(concepto.monto)}
              />

              {Array.isArray(concepto.retenciones) &&
              concepto.retenciones.length > 0 ? (
                concepto.retenciones.map((ret, i) => (
                  <Box key={i} sx={{ ml: 2, mt: 1 }}>
                    <ComprobanteRow
                      label="N° Retención:"
                      value={ret.numeroRetencion}
                    />
                    <ComprobanteRow
                      label="Tipo:"
                      value={ret.tipoRetencion}
                    />
                    <ComprobanteRow
                      label="Código Impuesto:"
                      value={ret.codigoImpuesto}
                    />
                    <ComprobanteRow
                      label="Código Régimen:"
                      value={ret.codigoRegimen}
                    />
                    <ComprobanteRow
                      label="Base Imponible:"
                      value={new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(ret.baseImponible)}
                    />
                    <ComprobanteRow
                      label="Alícuota:"
                      value={`${ret.alicuota} %`}
                    />
                    <ComprobanteRow
                      label="Retenciones: Importe Retenido:"
                      value={new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(ret.importeRetenido)}
                    />
                  </Box>
                ))
              ) : (
                <ComprobanteRow label="Retenciones:" value="" />
              )}
            </Box>
          ))
        ) : (
          <Typography>No hay conceptos disponibles.</Typography>
        )}
      </Box>
    </Box>
  );
};

const ComprobanteRow = ({ label, value }) => (
  <Box
    className="comprobanteContainer_rowBody"
    sx={{
      display: "flex",
      flexDirection: "row",
      gap: 1,
      mb: 1,
    }}
  >
    <Box sx={{ fontWeight: 500 }}>{label}</Box>
    <Box sx={{ color: "#333" }}>{value}</Box>
  </Box>
);

export default ReceiptPaymentOrder;
